import Ladda from "ladda";
import 'ladda/dist/ladda-themeless.min.css';
import sass_vars from 'AssetsSass/_variables.scss';

export class TypeAction {
  wait_time = 1000;
  el = null;

  constructor(wait_time, el) {
    this.wait_time = wait_time ?? 1000;
    this.el = el;
  }

  fire() {
    this.el.disabled = true;
  }

  recover() {
    this.el.disabled = false;
  }

  async run() {
    try {
      this.fire();
      await new Promise(res => setTimeout(res, this.wait_time ?? 1000));
      await this.recover();
    } catch (err) {
      console.error(err);
    }
  }
}

export class TAButton extends TypeAction {
  constructor(wait_time, el) {
    super(wait_time, el);
    this.ladda_el = Ladda.create(el);
    this.el.dataset.spinnerColor = sass_vars['hunter-grey'];
  }

  fire() {
    this.ladda_el.start();
  }

  recover() {
    this.ladda_el.stop();
  }
}

export function makeTA(el, binding) {
  switch (el.type) {
    case `button`:
      return new TAButton(binding.value, el);
    default:
      return new TypeAction(binding.value, el);
  }
}
